<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Store</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.stores.index')">
                                    Store
                                </Link>
                            </li>
                            <li class="breadcrumb-item active">{{ isEditing ? "Edit" : "Add" }} Store
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="saveStore">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Store Name</label>
                                        <input type="text" v-model="store.name" class="form-control"
                                               placeholder="Store Name"
                                               required>
                                        <div v-if="store.errors.name" class="text-danger text-small">
                                            {{ store.errors.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Store State</label>
                                        <select v-model="store.state_id" id="" class="form-control" required>
                                            <option :value="null">Select a State</option>
                                            <option v-for="state in states" :key="state.id"
                                                    :value="state.id">
                                                {{ state.name }}
                                            </option>
                                        </select>
                                        <span v-if="store.errors.state_id"
                                              class="text-danger text-small">{{ store.errors.state_id }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Store Address</label>
                                        <input type="text" v-model="store.area" class="form-control"
                                               placeholder="Store Area"
                                               required>
                                        <div v-if="store.errors.area" class="text-danger text-small">
                                            {{ store.errors.area }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Store City</label>
                                        <select v-model="store.city_id" id="" class="form-control" required>
                                            <option :value="null">Select a City</option>
                                            <option v-for="city in citiesInState" :key="city.id"
                                                    :value="city.id">
                                                {{ city.name }}
                                            </option>
                                        </select>
                                        <span v-if="store.errors.city_id"
                                              class="text-danger text-small">{{ store.errors.city_id }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6" v-if="!isEditing">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Clone Store</label>
                                        <select v-model="store.store_to_clone" id="" class="form-control">
                                            <option :value="null">Select a Store</option>
                                            <option v-for="availableStore in availableStores" :key="availableStore.id"
                                                    :value="availableStore.id">
                                                {{ availableStore.name }}
                                            </option>
                                        </select>
                                        <span v-if="store.errors.store_to_clone"
                                              class="text-danger text-small">{{ store.errors.store_to_clone }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Pickup Opening Time</label>
                                        <input type="time" v-model="store.opening_time" class="form-control"
                                               placeholder="Pickup Opening Time">
                                        <small class="text-muted">Leave empty to use general business hours.</small>
                                        <span v-if="store.errors.opening_time"
                                              class="text-danger text-small d-block">{{ store.errors.opening_time }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Pickup Closing Time</label>
                                        <input type="time" v-model="store.closing_time" class="form-control"
                                               placeholder="Pickup Closing Time">
                                        <span v-if="store.errors.closing_time"
                                              class="text-danger text-small">{{ store.errors.closing_time }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Delivery Opening Time</label>
                                        <input type="time" v-model="store.delivery_opening_time" class="form-control"
                                               placeholder="Delivery Opening Time">
                                        <small class="text-muted">Leave empty to use general business hours.</small>
                                        <span v-if="store.errors.delivery_opening_time"
                                              class="text-danger text-small d-block">{{ store.errors.delivery_opening_time }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Delivery Closing Time</label>
                                        <input type="time" v-model="store.delivery_closing_time" class="form-control"
                                               placeholder="Delivery Closing Time">
                                        <span v-if="store.errors.delivery_closing_time"
                                              class="text-danger text-small">{{ store.errors.delivery_closing_time }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Longitude</label>
                                        <input type="text" v-model="store.longitude" class="form-control"
                                               placeholder="Store Longitude"
                                               required>
                                        <div v-if="store.errors.longitude" class="text-danger text-small">
                                            {{ store.errors.longitude }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Latitude</label>
                                        <input type="text" v-model="store.latitude" class="form-control"
                                               placeholder="Store Latitude"
                                               required>
                                        <div v-if="store.errors.latitude" class="text-danger text-small">
                                            {{ store.errors.latitude }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Kilimanjaro Restaurant Id</label>
                                        <input type="text" v-model="store.kilimanjaro_restaurant_id"
                                               class="form-control"
                                               placeholder="Kilimanjaro Restaurant Id"
                                        >
                                        <span v-if="store.kilimanjaro_restaurant_name"
                                              class="text-success text-small">
                                            {{ store.kilimanjaro_restaurant_name }}
                                        </span>
                                        <span v-if="storeError" class="text-danger text-small">{{ storeError }}</span>
                                        <span v-if="store.errors.kilimanjaro_restaurant_id"
                                              class="text-danger text-small">
                                            {{ store.errors.kilimanjaro_restaurant_id }}
                                        </span>
                                        <span v-if="store.errors.kilimanjaro_restaurant_name"
                                              class="text-danger text-small">
                                            {{ store.errors.kilimanjaro_restaurant_name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" v-model="store.is_active"
                                                   id="defaultCheck2"
                                                   :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck2">
                                                Is this Store active?
                                            </label>
                                        </div>
                                        <span v-if="store.errors.is_active"
                                              class="text-danger text-small">{{ store.errors.is_active }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck1"
                                                   v-model="store.store_free_delivery" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck1">
                                                Allow Free delivery from Kilimanjaro Restaurant
                                            </label>
                                        </div>
                                        <span v-if="store.errors.store_free_delivery"
                                              class="text-danger text-small">{{ store.errors.store_free_delivery }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck3"
                                                   v-model="store.is_opened" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck3">
                                                Is this Store Opened?
                                            </label>
                                        </div>
                                        <span v-if="store.errors.is_opened"
                                              class="text-danger text-small">{{ store.errors.is_opened }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" v-model="store.delivery_active"
                                                   id="defaultCheck5"
                                                   :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck5">
                                                Is Delivery active for this Store?
                                            </label>
                                        </div>
                                        <span v-if="store.errors.delivery_active"
                                              class="text-danger text-small">{{ store.errors.delivery_active }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" v-model="store.pickup_active"
                                                   id="defaultCheck6"
                                                   :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck6">
                                                Is Pickup active for this Store?
                                            </label>
                                        </div>
                                        <span v-if="store.errors.pickup_active"
                                              class="text-danger text-small">{{ store.errors.pickup_active }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-group">
                                    <label>Contact phone numbers</label>
                                    <div v-for="(phone, phoneIndex) in store.contact_phones" :key="phoneIndex" class="input-group mb-1">
                                        <input type="text" class="form-control" v-model="store.contact_phones[phoneIndex]" placeholder="Phone number">
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-outline-danger" @click="removePhone(phoneIndex)">Remove</button>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="addPhone">Add number</button>
                                    <span v-if="store.errors.contact_phones" class="text-danger text-small d-block">{{ store.errors.contact_phones }}</span>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            <template v-if="isEditing">
                <section class="card" id="delivery-prices">
                    <div class="card-body">
                        <h4 class="form-section mb-4"><i class="feather icon-shopping-cart"></i> Delivery Prices</h4>
                        <div class="row">
                            <template v-for="(n,index) in formCount">
                                <div class="col-md-4">
                                    <div class="form-group"><label>Min. Distance</label> <br>
                                        <div class="input-group">
                                            <input type="number" v-model="deliveryPrices[index].minimum_distance"
                                                   placeholder="Minimum Distance" required
                                                   class="form-control">
                                            <div class="input-group-append"><span class="input-group-text">m</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group"><label>Max. Distance</label> <br>
                                        <div class="input-group">
                                            <input type="number" v-model="deliveryPrices[index].maximum_distance"
                                                   placeholder="Maximum Distance" required
                                                   class="form-control">
                                            <div class="input-group-append"><span class="input-group-text">m</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group"><label>Price</label> <br>
                                        <div class="input-group">
                                            <div class="input-group-prepend"><span class="input-group-text">₦</span>
                                            </div>
                                            <input type="number" v-model="deliveryPrices[index].price"
                                                   placeholder="Price" required
                                                   class="form-control">
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="col-md-12">
                            <span>
                                <a href="#delivery-prices" @click="addToFormCount">Add +</a>
                            </span>

                                <span v-if="formCount > 1">
                                <a href="#delivery-prices" @click="subtractFromFormCount"
                                   class="text-danger">- Remove</a>
                            </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" @click="updateDeliveryPrice"
                                        class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1">
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </template>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";

export default {
    metaInfo: {title: 'Create Store'},
    name: 'StoreCreate',
    props: [
        'stores',
        'cities',
        'states',
        'isEditing',
        'storeData',
        'deliveryPricesData',
        'availableStores',
    ],
    components: {
        Link,
    },
    layout: Layout,
    data() {
        return {
            store: this.$inertia.form({
                longitude: null,
                latitude: null,
                name: null,
                area: null,
                is_active: false,
                is_opened: false,
                state_id: null,
                city_id: null,
                bank_name: null,
                account_name: null,
                account_number: null,
                show_account_details: false,
                store_to_clone: null,
                opening_time: null,
                closing_time: null,
                delivery_opening_time: null,
                delivery_closing_time: null,
                store_free_delivery: false,
                kilimanjaro_restaurant_id: null,
                kilimanjaro_restaurant_name: null,
                delivery_active: false,
                pickup_active: false,
                contact_phones: [''],
            }),
            deliveryPrices: [],
            formCount: this.deliveryPricesData.length === 0 ? 1 : this.deliveryPricesData.length,
            saving: false,
            storeError: ''
        }
    },
    watch: {
        'store.kilimanjaro_restaurant_id'(value) {
            this.store.kilimanjaro_restaurant_name = '';
            // clear previous timer
            clearTimeout(this.typingTimer);

            // wait 500ms after user stops typing
            this.typingTimer = setTimeout(() => {
                this.validateStore(value);
            }, 500);
        }
    },
    computed: {
        citiesInState() {
            let stateId = this.store.state_id
            return stateId ? this.cities.filter((city) => city.state_id === stateId) : [];
        }
    },
    methods: {
        addPhone() {
            this.store.contact_phones.push('');
        },
        removePhone(index) {
            this.store.contact_phones.splice(index, 1);
            if (this.store.contact_phones.length === 0) {
                this.store.contact_phones.push('');
            }
        },
        addToFormCount() {
            this.formCount += 1;
            this.deliveryPrices.push({
                minimum_distance: null,
                maximum_distance: null,
                price: null
            });
        },
        subtractFromFormCount() {
            if (this.formCount > 1) {
                this.formCount -= 1;
                this.deliveryPrices.pop();
            } else {
                this.formCount = 1;
            }
        },

        async updateDeliveryPrice() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            };

            await this.$inertia.post(route('admin.stores.delivery.prices', this.storeData.id), {delivery_prices: [...this.deliveryPrices]}, options);
            this.saving = false;
        },

        async saveStore() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            };

            this.isEditing ?
                this.store.put(route('admin.stores.update', this.storeData.id), options)
                :
                this.store.post(route('admin.stores.store'), options);
        },
        async validateStore(storeId) {
            if (! storeId) {
                this.store.kilimanjaro_restaurant_name = '';
                this.storeError = ''
                return;
            }

            try {
                const res = await axios.post('/api/v1/check-other-store', {
                    restaurant_id: storeId
                });

                this.storeError = '';
                this.store.kilimanjaro_restaurant_name = res.data.data.restaurant_name;
            } catch (e) {
                this.storeError = 'Invalid store Id';
                this.store.kilimanjaro_restaurant_name = '';
            }
        }
    },
    mounted() {
        if (this.isEditing) {
            const {longitude, latitude, name, area, is_active, is_opened, state_id, city_id,show_account_details, account_number, account_name, bank_name, store_free_delivery, kilimanjaro_restaurant_id, kilimanjaro_restaurant_name, delivery_active, pickup_active, opening_time, closing_time, delivery_opening_time, delivery_closing_time, contact_phones} = this.storeData;
            const normalizeTime = (value) => value ? String(value).substring(0, 5) : null;
            this.store = {
                ...this.store,
                longitude, latitude, name, area, is_active, is_opened, state_id, city_id,
                show_account_details, account_number, account_name, bank_name, store_free_delivery,
                kilimanjaro_restaurant_id, kilimanjaro_restaurant_name, delivery_active, pickup_active,
                opening_time: normalizeTime(opening_time),
                closing_time: normalizeTime(closing_time),
                delivery_opening_time: normalizeTime(delivery_opening_time),
                delivery_closing_time: normalizeTime(delivery_closing_time),
                contact_phones: Array.isArray(contact_phones) && contact_phones.length ? contact_phones : [''],
            };

            let deliveryPrices = [];
            this.deliveryPricesData.map(function (item) {
                deliveryPrices.push({
                    minimum_distance: item.minimum_distance,
                    maximum_distance: item.maximum_distance,
                    price: item.price
                })
            })
            this.deliveryPrices = deliveryPrices.length===0 ? [{
                minimum_distance: null,
                maximum_distance: null,
                price: null
            }] : deliveryPrices;
        }
    },
}
</script>
`
